export default __webpack_public_path__ + "static/media/digital_en.53759cb0.png";